import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Mon Oct 08 2018
 * @author SKu
 * @author BPo
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { FinalProductPriceConverter, jsonConversions, ProductPricesUploadConverter, Release, ReleaseConverter, ReleaseItemConverter, ReleaseTotalDTOConverter, ReleaseType, SelloutImpactRecordConverter, SelloutRelease, SelloutReleaseCategoryTotalDTOConverter, SelloutReleaseConverter, SelloutReleaseItemConverter, SelloutReleaseItemUpdateRequestConverter, SelloutReleaseTotalDTOConverter, ReleaseItemPromosConverter, ImpactRecordConverter, SelloutTargetConverter, SelloutProductPriceImpactConverter, SiteReleaseUploadConverter, SiteReleaseConverter, SiteReleaseItemConverter, ReleasePartConverter, CommonReleaseOverviewConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { List } from 'immutable';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import moment from 'moment';
export var ReleaseLayer =
/*#__PURE__*/
function () {
  function ReleaseLayer() {
    _classCallCheck(this, ReleaseLayer);
  }

  _createClass(ReleaseLayer, [{
    key: "convertRelease",

    /**
     * Function used for abstract converting any type of release
     * @param release that should be converted
     * @returns release as object
     */
    value: function convertRelease(release) {
      return release.releaseType === ReleaseType.Sellout ? SelloutRelease.requireSelloutRelease(this.selloutReleaseConverter.toObject(release, jsonConversions)) : Release.requireRegularRelease(this.releaseConverter.toObject(release, jsonConversions));
    }
    /**
     * Function concat base url and additional
     * @param path - additional path
     * @returns final url for api call
     */

  }, {
    key: "getUrl",
    value: function getUrl(path) {
      return path ? "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.RELEASES).concat(path) : "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.RELEASES);
    }
    /***********************************************COMMON ENDPOINTS*******************************************************************/

    /**
     * Fetches releases
     * @param params - query parameters(states)
     * @returns Map of Releases {Release | SelloutRelease}
     */

  }, {
    key: "findAll",
    value: function findAll(params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var config, _ref, data, list;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = Object.assign(Object.assign({}, this.config), {
                  params: params
                });
                _context.next = 3;
                return api(this.getUrl()).get(config);

              case 3:
                _ref = _context.sent;
                data = _ref.data;
                list = new Map();
                (data.result || []).map(function (item) {
                  return list.set(item.id, _this.convertRelease(item));
                });
                return _context.abrupt("return", list);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Fetches release overviews.
     * @param params - query parameters(states)
     * @returns
     */

  }, {
    key: "findOverviews",
    value: function findOverviews(params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var config, endpoint, _ref2, data, list;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                config = Object.assign(Object.assign({}, this.config), {
                  params: params
                });
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASES_OVERVIEW);
                _context2.next = 4;
                return api(endpoint).get(config);

              case 4:
                _ref2 = _context2.sent;
                data = _ref2.data;
                list = new Map();
                (data.result || []).map(function (item) {
                  return list.set(item.id, _this2.commonReleaseOverviewConverter.toObject(item, jsonConversions));
                });
                return _context2.abrupt("return", list);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Fetches releases depending on user roles ot other events specified on BE
     * @returns Map of Releases {Release | SelloutRelease}
     */

  }, {
    key: "findAllForDashboard",
    value: function findAllForDashboard() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var endpoint, _ref3, data, list;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASES_DASHBOARD);
                _context3.next = 3;
                return api(endpoint).get();

              case 3:
                _ref3 = _context3.sent;
                data = _ref3.data;
                list = new Map();
                (data.result || []).map(function (item) {
                  return list.set(item.id, _this3.convertRelease(item));
                });
                return _context3.abrupt("return", list);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Gets one particular item based on it's id from repository
     * @param id Release ID
     * @returns one particular item from repository
     */

  }, {
    key: "findOne",
    value: function findOne(id) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var config, endpoint, _ref4, data;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                config = Object.assign(Object.assign({}, this.config), {
                  params: {
                    editInfo: true
                  }
                });
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASES_ONE(id));
                _context4.next = 4;
                return api(endpoint).get(config);

              case 4:
                _ref4 = _context4.sent;
                data = _ref4.data;
                return _context4.abrupt("return", this.convertRelease(data));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Opens the release with current settings of product categories. Returns updated release.
     * @param id Release ID
     * @returns Opened Release(could be sellout)
     */

  }, {
    key: "open",
    value: function open(id) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var endpoint, _ref5, data;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_OPEN(id));
                _context5.next = 3;
                return api(endpoint).post({}, this.config);

              case 3:
                _ref5 = _context5.sent;
                data = _ref5.data;
                return _context5.abrupt("return", this.convertRelease(data));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
    /**
     * Creates new Regular or Simulation Release
     * @param release New created Release
     * @returns created Release
     */

  }, {
    key: "create",
    value: function create(release) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var endpoint, _ref6, data;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                endpoint = this.getUrl();
                _context6.next = 3;
                return api(endpoint).post(release, this.config);

              case 3:
                _ref6 = _context6.sent;
                data = _ref6.data;
                return _context6.abrupt("return", this.releaseConverter.toObject(data, jsonConversions));

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
    /**
     * Creates new Sellout Release
     * @param release New created Sellout Release
     * @returns created SelloutRelease
     */

  }, {
    key: "createSellout",
    value: function createSellout(release) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var endpoint, _ref7, data;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.CREATE_SELLOUT_RELEASE);
                _context7.next = 3;
                return api(endpoint).post(release, this.config);

              case 3:
                _ref7 = _context7.sent;
                data = _ref7.data;
                return _context7.abrupt("return", this.selloutReleaseConverter.toObject(data, jsonConversions));

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
    /**
     * Updates release header
     * @param release Updated Release
     * @returns Release
     */

  }, {
    key: "update",
    value: function update(release) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var releaseAsDocument, endpoint, _ref8, data;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                releaseAsDocument = this.releaseConverter.toDocument(release, jsonConversions);
                endpoint = this.getUrl("/".concat(release.id));
                _context8.next = 4;
                return api(endpoint).put(releaseAsDocument, this.config);

              case 4:
                _ref8 = _context8.sent;
                data = _ref8.data;
                return _context8.abrupt("return", this.releaseConverter.toObject(data, jsonConversions));

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
    /**
     * Updates sellout release header
     * @param release Updated Release
     * @returns Release
     */

  }, {
    key: "updateSellout",
    value: function updateSellout(release) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var releaseAsDocument, endpoint, _ref9, data;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                releaseAsDocument = this.selloutReleaseConverter.toDocument(release, jsonConversions);
                endpoint = this.getUrl("/".concat(release.id));
                _context9.next = 4;
                return api(endpoint).put(releaseAsDocument, this.config);

              case 4:
                _ref9 = _context9.sent;
                data = _ref9.data;
                return _context9.abrupt("return", this.selloutReleaseConverter.toObject(data, jsonConversions));

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
    /**
     * Sets release as Favorite or vice versa
     * @param id - releaseId
     * @param state - new favorability state
     * @returns Updated release
     */

  }, {
    key: "setReleaseFavorability",
    value: function setReleaseFavorability(id, state) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var endpoint, _ref10, data;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_FAVORITE(id));
                _context10.next = 3;
                return api(endpoint).post({
                  state: state
                }, this.config);

              case 3:
                _ref10 = _context10.sent;
                data = _ref10.data;
                return _context10.abrupt("return", this.convertRelease(data));

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
    /**
     * Affect release with action from ReleaseAction enum
     * @param params
     * @returns FIXME: docs
     */

  }, {
    key: "action",
    value: function action(params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var endpoint, _ref11, data;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_ACTION(params.releaseId));
                _context11.next = 3;
                return api(endpoint).post(params, this.config);

              case 3:
                _ref11 = _context11.sent;
                data = _ref11.data;
                return _context11.abrupt("return", data);

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
    /**
     * Uploads prices for products. Returns validation messages.
     * @param id Release ID
     * @param formData key/value pairs representing form fields
     * @param onUploadProgress allows handling of progress events for uploads
     * @returns ProductPricesUpload with progress monitor id
     */

  }, {
    key: "priceUpload",
    value: function priceUpload(id, formData, onUploadProgress) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var config, headers, endpoint, _ref12, data;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                config = Object.assign(Object.assign({}, this.config), {
                  onUploadProgress: onUploadProgress
                });
                headers = {
                  'Content-type': 'multipart/form-data'
                };
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_UPLOAD_PRICES(id));
                _context12.next = 5;
                return api(endpoint).setHeaders(headers).post(formData, config);

              case 5:
                _ref12 = _context12.sent;
                data = _ref12.data;
                return _context12.abrupt("return", this.productPricesUploadConverter.toObject(data, jsonConversions));

              case 8:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
    /**
     * Uploads prices for products . Returns validation messages.
     * @param id Release ID
     * @param uploadId Upload id
     * @returns ProductPricesUpload
     */

  }, {
    key: "getUploadedPrice",
    value: function getUploadedPrice(id, uploadId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        var endpoint, _ref13, data;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_UPLOADED_PRICES(id, uploadId));
                _context13.next = 3;
                return api(endpoint).get();

              case 3:
                _ref13 = _context13.sent;
                data = _ref13.data;
                return _context13.abrupt("return", this.productPricesUploadConverter.toObject(data, jsonConversions));

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
    /**
     * Get price list setting
     */

  }, {
    key: "getPriceListSettings",
    value: function getPriceListSettings() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        var endpoint, data;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_GET_PRICE_LIST_SETTING);
                _context14.next = 3;
                return api(endpoint).get({
                  responseType: 'json'
                }).then(function (response) {
                  var arr = [];
                  (response.data.result || []).map(function (item) {
                    arr.push(item);
                  });
                  return arr;
                }).catch(function (error) {
                  return Promise.reject(error);
                });

              case 3:
                data = _context14.sent;
                return _context14.abrupt("return", data);

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));
    }
    /***********************************************COMMON ENDPOINTS*******************************************************************/

    /*******************************************REGULAR RELEASE ENDPOINTS**************************************************************/

    /**
     * Function fetches total overview for release
     * @param releaseId
     * @param filter - filter for fetching total
     * @returns Array of ReleaseTotalDTO
     */

  }, {
    key: "findTotals",
    value: function findTotals(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        var _this4 = this;

        var endpoint, _ref14, data;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_TOTAL(releaseId));
                _context15.next = 3;
                return api(endpoint).post(filter, this.config);

              case 3:
                _ref14 = _context15.sent;
                data = _ref14.data;
                return _context15.abrupt("return", (data.result || []).map(function (item) {
                  return _this4.releaseTotalDTOConverter.toObject(item, jsonConversions);
                }));

              case 6:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
    /**
     * Function fetches total overview for release
     * @param releaseId
     * @param filter - filter for fetching total
     * @returns Array of ReleaseTotalDTO
     */

  }, {
    key: "findSubtotals",
    value: function findSubtotals(releaseId, categoryId, releaseItemIds) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16() {
        var _this5 = this;

        var endpoint, _ref15, data;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SUBTOTAL(releaseId, categoryId));
                _context16.next = 3;
                return api(endpoint).post({
                  releaseItemIds: releaseItemIds
                }, this.config);

              case 3:
                _ref15 = _context16.sent;
                data = _ref15.data;
                return _context16.abrupt("return", (data.result || []).map(function (item) {
                  return _this5.impactRecordConverter.toObject(item, jsonConversions);
                }));

              case 6:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
    /**
     * Function release items for release
     * @param releaseId
     * @param filter - filter for fetching items
     * @returns Map of ReleaseItem
     */

  }, {
    key: "findItems",
    value: function findItems(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17() {
        var _this6 = this;

        var config, endpoint, _ref16, data, list;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                config = Object.assign(Object.assign({}, this.config), {
                  params: filter
                });
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_ITEMS(releaseId));
                _context17.next = 4;
                return api(endpoint).get(config);

              case 4:
                _ref16 = _context17.sent;
                data = _ref16.data;
                list = new Map();
                (data.result || []).map(function (item) {
                  return list.set(item.productId, _this6.releaseItemsConverter.toObject(item, jsonConversions));
                });
                return _context17.abrupt("return", list);

              case 9:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
    /**
     * Function updates 'export' flag for releaseItem
     * @param releaseId
     * @param exported - new value of Release Item
     * @returns all changed ReleaseItem objects
     */

  }, {
    key: "exportItem",
    value: function exportItem(releaseItemId, exported) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18() {
        var _this7 = this;

        var endpoint, _ref17, data;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_ITEM_EXPORTED(releaseItemId));
                _context18.next = 3;
                return api(endpoint).post({
                  exported: exported
                }, this.config);

              case 3:
                _ref17 = _context18.sent;
                data = _ref17.data;
                return _context18.abrupt("return", List(data.result.map(function (item) {
                  return _this7.releaseItemsConverter.toObject(item, jsonConversions);
                })));

              case 6:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
    }
    /**
     * Function updates PriceCode of certain priceZone for releaseItem
     * @param releaseItemId
     * @param params {priceZoneId: string; priceCode: string}
     * @returns updated ReleaseItem
     */

  }, {
    key: "editItemPriceCode",
    value: function editItemPriceCode(releaseItemId, params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19() {
        var endpoint, _ref18, data;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_ITEM_PRICE_CODE(releaseItemId));
                _context19.next = 3;
                return api(endpoint).post(params, this.config);

              case 3:
                _ref18 = _context19.sent;
                data = _ref18.data;
                return _context19.abrupt("return", this.releaseItemsConverter.toObject(data, jsonConversions));

              case 6:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }
    /**
     * Function updates FinalPrice of certain priceZone for releaseItem
     * @param releaseItemId
     * @param finalPrice {FinalProductPrice}
     * @returns updated ReleaseItem
     */

  }, {
    key: "editItemFinalPrice",
    value: function editItemFinalPrice(releaseItemId, finalPrice) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20() {
        var _this8 = this;

        var finalPriceAsDocument, endpoint, _ref19, data;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                finalPriceAsDocument = this.finalProductPriceConverter.toDocument(finalPrice, jsonConversions);
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_ITEM_FINAL_PRICE(releaseItemId));
                _context20.next = 4;
                return api(endpoint).post(finalPriceAsDocument, this.config);

              case 4:
                _ref19 = _context20.sent;
                data = _ref19.data;
                return _context20.abrupt("return", (data.result || []).map(function (item) {
                  return _this8.releaseItemsConverter.toObject(item, jsonConversions);
                }));

              case 7:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));
    }
    /**
     * Function updates FinalPrice of certain priceZone for releaseItem
     * @param releaseItemId
     * @param comment {PriceComment Entity}
     * @returns updated ReleaseItem
     */

  }, {
    key: "createItemComment",
    value: function createItemComment(releaseItemId, comment) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21() {
        var endpoint, _ref20, data;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_ITEM_COMMENT(releaseItemId));
                _context21.next = 3;
                return api(endpoint).post(comment, this.config);

              case 3:
                _ref20 = _context21.sent;
                data = _ref20.data;
                return _context21.abrupt("return", this.releaseItemsConverter.toObject(data, jsonConversions));

              case 6:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
    }
    /**
     * Copy Release MatrixTable settings to general settings
     * @param id Release ID
     * @returns {boolean} if action was successful
     */

  }, {
    key: "saveToGeneralSettings",
    value: function saveToGeneralSettings(id) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22() {
        var endpoint, _ref21, data;

        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_COPY_TO_GENERAL_SETTINGS(id));
                _context22.next = 3;
                return api(endpoint).post(this.config);

              case 3:
                _ref21 = _context22.sent;
                data = _ref21.data;
                return _context22.abrupt("return", data.success);

              case 6:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));
    }
    /**
     * List of promotions for the tooltip
     * @param id - releaseItemId
     * @param zoneId - priceZoneId
     */

  }, {
    key: "findPromos",
    value: function findPromos(id, zoneId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23() {
        var endpoint, _ref22, data;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_PROMO(id, zoneId));
                _context23.next = 3;
                return api(endpoint).get();

              case 3:
                _ref22 = _context23.sent;
                data = _ref22.data;
                return _context23.abrupt("return", this.releaseItemPromosConverter.toObject(data, jsonConversions));

              case 6:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
    }
  }, {
    key: "updateReleasPartManualPrices",
    value: function updateReleasPartManualPrices(releaseId, categoryId, manualPrices) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24() {
        var enpoint, _ref23, data;

        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                enpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_PART_MANUAL_PRICES_UPDATE(releaseId, categoryId));
                _context24.next = 3;
                return api(enpoint).patch({
                  manualPrices: manualPrices
                }, {
                  responseType: 'json'
                });

              case 3:
                _ref23 = _context24.sent;
                data = _ref23.data;
                return _context24.abrupt("return", this.releasePartConverter.toObject(data, jsonConversions));

              case 6:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));
    }
  }, {
    key: "recalculateNeededReleaseParts",
    value: function recalculateNeededReleaseParts(releaseId, manualPrices) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee25() {
        var enpoint, _ref24, data;

        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                enpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_RECALCULATE_RELEASE_PARTS(releaseId));
                _context25.next = 3;
                return api(enpoint).post({
                  manualPrices: manualPrices
                }, {
                  responseType: 'json'
                });

              case 3:
                _ref24 = _context25.sent;
                data = _ref24.data;
                return _context25.abrupt("return", data);

              case 6:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));
    }
    /*******************************************REGULAR RELEASE ENDPOINTS**************************************************************/

    /*******************************************SELLOUT RELEASE ENDPOINTS**************************************************************/

    /**
     * Function fetches total overview for sellout releases
     * @param releaseId
     * @param filter - filter for fetching total
     * @returns Array of SelloutReleaseTotalDTO
     */

  }, {
    key: "findSelloutTotal",
    value: function findSelloutTotal(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee26() {
        var _this9 = this;

        var endpoint, _ref25, data;

        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_TOTAL(releaseId));
                _context26.next = 3;
                return api(endpoint).post(filter, this.config);

              case 3:
                _ref25 = _context26.sent;
                data = _ref25.data;
                return _context26.abrupt("return", (data.result || []).map(function (item) {
                  return _this9.selloutReleaseTotalDTOConverter.toObject(item, jsonConversions);
                }));

              case 6:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));
    }
    /**
     * Fetches totals as ImpactRecords for detail category page
     * @param releaseId
     * @param categoryId
     * @returns array of SelloutImpactRecord
     */

  }, {
    key: "findSelloutCategoryTotal",
    value: function findSelloutCategoryTotal(releaseId, categoryId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27() {
        var _this10 = this;

        var endpoint, _ref26, data;

        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_CATEGORY_TOTAL(releaseId, categoryId));
                _context27.next = 3;
                return api(endpoint).get(this.config);

              case 3:
                _ref26 = _context27.sent;
                data = _ref26.data;
                return _context27.abrupt("return", (data.result || []).map(function (item) {
                  return _this10.selloutImpactRecordConverter.toObject(item, jsonConversions);
                }));

              case 6:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));
    }
    /**
     * Fetches subtotal as ImpactRecord for detail category page
     * @param id - releaseId
     * @param catId - categoryId
     * @param filter
     * @returns SelloutImpactRecord one element
     */

  }, {
    key: "findSelloutCategorySubTotal",
    value: function findSelloutCategorySubTotal(id, catId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee28() {
        var endpoint, _ref27, data;

        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_CATEGORY_SUBTOTAL(id, catId));
                _context28.next = 3;
                return api(endpoint).post(filter, this.config);

              case 3:
                _ref27 = _context28.sent;
                data = _ref27.data;
                return _context28.abrupt("return", this.selloutImpactRecordConverter.toObject(data, jsonConversions));

              case 6:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));
    }
    /**
     * Fetches list of previous subtotal as ImpactRecord list for detail category page
     * @param id - releaseId
     * @param catId - categoryId
     * @param filter
     * @returns SelloutImpactRecord one element
     */

  }, {
    key: "findSelloutCategoryPreviousSubTotal",
    value: function findSelloutCategoryPreviousSubTotal(id, catId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee29() {
        var _this11 = this;

        var endpoint, _ref28, data;

        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_CATEGORY_SUBTOTAL_PREVIOUS(id, catId));
                _context29.next = 3;
                return api(endpoint).post(filter, this.config);

              case 3:
                _ref28 = _context29.sent;
                data = _ref28.data;
                return _context29.abrupt("return", List(data.map(function (item) {
                  return _this11.selloutImpactRecordConverter.toObject(item, jsonConversions);
                })));

              case 6:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));
    }
    /**
     * Fetches list of all subtotal as ImpactRecord list for detail category page
     * @param id - releaseId
     * @param catId - categoryId
     * @param filter
     * @returns SelloutImpactRecord one element
     */

  }, {
    key: "findSelloutCategoryAllSubTotal",
    value: function findSelloutCategoryAllSubTotal(id, catId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee30() {
        var _this12 = this;

        var endpoint, _ref29, data;

        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_CATEGORY_SUBTOTAL_COMBINED(id, catId));
                _context30.next = 3;
                return api(endpoint).post(filter, this.config);

              case 3:
                _ref29 = _context30.sent;
                data = _ref29.data;
                return _context30.abrupt("return", List(data.map(function (item) {
                  return _this12.selloutImpactRecordConverter.toObject(item, jsonConversions);
                })));

              case 6:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));
    }
    /**
     * Fetches category items for detail category page
     * @param id - releaseId
     * @param catId - categoryId
     * @param filter
     * @returns Map of SelloutReleaseCategoryTotalDTOs
     */

  }, {
    key: "findSelloutCategoryItems",
    value: function findSelloutCategoryItems(id, catId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee31() {
        var _this13 = this;

        var endpoint, _ref30, data, list;

        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_CATEGORY_ITEMS(id, catId));
                _context31.next = 3;
                return api(endpoint).post(filter, this.config);

              case 3:
                _ref30 = _context31.sent;
                data = _ref30.data;
                list = new Map();
                (data.result || []).map(function (item) {
                  return list.set(item.productId, _this13.selloutReleaseCategoryTotalDTOConverter.toObject(item, jsonConversions));
                });
                return _context31.abrupt("return", list);

              case 8:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));
    }
    /**
     *    returns aggregated price impact on products level
     */

  }, {
    key: "findSelloutCategoryItemsRealImpact",
    value: function findSelloutCategoryItemsRealImpact(id, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee32() {
        var _this14 = this;

        var config, endpoint, _ref31, data, list;

        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                config = Object.assign(Object.assign({}, this.config), {
                  params: {
                    dateFrom: this.impactFilterToParams(filter).dateFrom,
                    dateTo: this.impactFilterToParams(filter).dateTo
                  }
                });
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.REAL_IMPACT_REPORT_SELLOUT_PRODUCTS(id));
                _context32.next = 4;
                return api(endpoint).post({
                  productIds: filter.productIds,
                  categoryIds: filter.categoryIds
                }, config);

              case 4:
                _ref31 = _context32.sent;
                data = _ref31.data;
                list = new Map();
                (data.result || []).map(function (item) {
                  return list.set(item.productId, _this14.selloutProductPriceImpactConverter.toObject(item, jsonConversions).realImpact);
                });
                return _context32.abrupt("return", list);

              case 9:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));
    }
    /**
     * Fetches category items for  export page
     * @param id - releaseId
     * @param filter
     * @returns Map of SelloutReleaseCategoryTotalDTOs
     */

  }, {
    key: "findExportedSelloutCategoryTotals",
    value: function findExportedSelloutCategoryTotals(id, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee33() {
        var _this15 = this;

        var endpoint, _ref32, data, list;

        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_CATEGORY_ITEMS_EXPORT(id));
                _context33.next = 3;
                return api(endpoint).post(filter, this.config);

              case 3:
                _ref32 = _context33.sent;
                data = _ref32.data;
                list = new Map();
                (data.result || []).map(function (item) {
                  return list.set(item.productId, _this15.selloutReleaseCategoryTotalDTOConverter.toObject(item, jsonConversions));
                });
                return _context33.abrupt("return", list);

              case 8:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));
    }
    /**
     * Function fetches sellout items for release sellout item detail modal
     * inside detail category or export pages
     * @param releaseId
     * @param filter - filter for fetching items
     * @returns Map of SelloutReleaseItem
     */

  }, {
    key: "findSelloutItems",
    value: function findSelloutItems(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee34() {
        var _this16 = this;

        var config, endpoint, _ref33, data, list;

        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                config = Object.assign(Object.assign({}, this.config), {
                  params: filter
                });
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_ITEMS(releaseId));
                _context34.next = 4;
                return api(endpoint).get(config);

              case 4:
                _ref33 = _context34.sent;
                data = _ref33.data;
                list = new Map();
                (data.result || []).map(function (item) {
                  return list.set(item.id, _this16.selloutReleaseItemConverter.toObject(item, jsonConversions));
                });
                return _context34.abrupt("return", list);

              case 9:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));
    }
    /**
     * Function updates SelloutReleaseItem as bulk operation(could be used for dotted updates)
     * @param request updated item request
     * @returns updated SelloutReleaseItem
     */

  }, {
    key: "updateSelloutItems",
    value: function updateSelloutItems(request) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee35() {
        var _this17 = this;

        var requestAsDocument, endpoint, _ref34, data;

        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                requestAsDocument = this.selloutReleaseItemUpdateRequestConverter.toDocument(request, jsonConversions);
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_UPDATE_ITEMS);
                _context35.next = 4;
                return api(endpoint).post(requestAsDocument, this.config);

              case 4:
                _ref34 = _context35.sent;
                data = _ref34.data;
                return _context35.abrupt("return", (data.result || []).map(function (item) {
                  return _this17.selloutReleaseItemConverter.toObject(item, jsonConversions);
                }));

              case 7:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));
    }
    /**
     * List of promotions for the tooltip
     * @param id - releaseItemId
     */

  }, {
    key: "findSelloutPromos",
    value: function findSelloutPromos(id) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee36() {
        var endpoint, _ref35, data;

        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_PROMO(id));
                _context36.next = 3;
                return api(endpoint).get();

              case 3:
                _ref35 = _context36.sent;
                data = _ref35.data;
                return _context36.abrupt("return", this.releaseItemPromosConverter.toObject(data, jsonConversions));

              case 6:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));
    }
    /**
     * Endpoint for reopening sellout release
     * @param release
     */

  }, {
    key: "selloutReopen",
    value: function selloutReopen(release) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee37() {
        var endpoint, releaseDoc, _ref36, data;

        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_REOPEN);
                releaseDoc = this.selloutReleaseConverter.toDocument(release, jsonConversions);
                _context37.next = 4;
                return api(endpoint).put(releaseDoc);

              case 4:
                _ref36 = _context37.sent;
                data = _ref36.data;
                return _context37.abrupt("return", this.selloutReleaseConverter.toObject(data, jsonConversions));

              case 7:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));
    }
    /**
     * Endpoint for updating targetMargin & targetProfit
     * @param updates
     */

  }, {
    key: "selloutUpdateTargets",
    value: function selloutUpdateTargets(updates) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee38() {
        var _this18 = this;

        var endpoint, _ref37, data;

        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_UPDATE_TARGETS);
                _context38.next = 3;
                return api(endpoint).post({
                  updates: updates
                });

              case 3:
                _ref37 = _context38.sent;
                data = _ref37.data;
                return _context38.abrupt("return", (data.result || []).map(function (item) {
                  return _this18.selloutTargetConverter.toObject(item, jsonConversions);
                }));

              case 6:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));
    }
    /** Endpoint returns Array of priceListTypeIds in which user could not edit end Date */

  }, {
    key: "findPLTsWithFixedEndDate",
    value: function findPLTsWithFixedEndDate() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee39() {
        var endpoint, _ref38, data;

        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_PLT_WITH_FIXED_DATE);
                _context39.next = 3;
                return api(endpoint).get();

              case 3:
                _ref38 = _context39.sent;
                data = _ref38.data;
                return _context39.abrupt("return", data.result);

              case 6:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));
    }
  }, {
    key: "updateItemFilter",
    value: function updateItemFilter(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee40() {
        var enpoint, _ref39, data;

        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                enpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_FILTER_UPDATE(releaseId));
                _context40.next = 3;
                return api(enpoint).patch({
                  data: {
                    itemFilter: filter,
                    releaseId: releaseId
                  }
                }, {
                  responseType: 'json'
                });

              case 3:
                _ref39 = _context40.sent;
                data = _ref39.data;
                return _context40.abrupt("return", SelloutRelease.requireSelloutRelease(this.selloutReleaseConverter.toObject(data, jsonConversions)));

              case 6:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));
    }
  }, {
    key: "proceedPriceSimulation",
    value: function proceedPriceSimulation(id, release) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee41() {
        var endpoint, releaseDoc, _ref40, data;

        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_PRICE_SIMULATION(id));
                releaseDoc = this.selloutReleaseConverter.toDocument(release, jsonConversions);
                _context41.next = 4;
                return api(endpoint).post(releaseDoc, this.config);

              case 4:
                _ref40 = _context41.sent;
                data = _ref40.data;
                return _context41.abrupt("return", SelloutRelease.requireSelloutRelease(this.selloutReleaseConverter.toObject(data, jsonConversions)));

              case 7:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));
    }
  }, {
    key: "cancellPriceSimulation",
    value: function cancellPriceSimulation(id) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee42() {
        var endpoint, _ref41, data;

        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                endpoint = this.getUrl(CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_PRICE_SIMULATION_CANCELLATION(id));
                _context42.next = 3;
                return api(endpoint).patch({}, this.config);

              case 3:
                _ref41 = _context42.sent;
                data = _ref41.data;
                return _context42.abrupt("return", SelloutRelease.requireSelloutRelease(this.selloutReleaseConverter.toObject(data, jsonConversions)));

              case 6:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));
    }
  }, {
    key: "getSelloutStockValues",
    value: function getSelloutStockValues(releaseIds) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee43() {
        var endpoint, _ref42, data, list;

        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                endpoint = CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_IMPACT_STOCK_VALUES;
                _context43.next = 3;
                return api(endpoint).post(releaseIds, {
                  responseType: 'json'
                });

              case 3:
                _ref42 = _context43.sent;
                data = _ref42.data;
                list = new Map(); // TODO: conversion missing in this case - there is a mismatch between returned value and declared type.

                (data.result || []).map(function (item) {
                  return list.set(item.releaseId, item);
                });
                return _context43.abrupt("return", list);

              case 8:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43);
      }));
    }
  }, {
    key: "getPreviousImpacts",
    value: function getPreviousImpacts(releaseIds) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee44() {
        var _this19 = this;

        var endpoint, _ref43, data, result, _arr, _i, _arr$_i, releaseId, impactReports;

        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                endpoint = CONSTANTS.API.ENDPOINTS.RELEASE_SELLOUT_PREVIOUS_IMPACTS;
                _context44.next = 3;
                return api(endpoint).post(releaseIds, {
                  responseType: 'json'
                });

              case 3:
                _ref43 = _context44.sent;
                data = _ref43.data;
                result = new Map();
                _arr = Object.entries(data.result);

                for (_i = 0; _i < _arr.length; _i++) {
                  _arr$_i = _slicedToArray(_arr[_i], 2), releaseId = _arr$_i[0], impactReports = _arr$_i[1];
                  result.set(releaseId, List(impactReports.map(function (impactReport) {
                    return _this19.selloutImpactRecordConverter.toObject(impactReport, jsonConversions);
                  })));
                }

                return _context44.abrupt("return", result);

              case 9:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44);
      }));
    }
    /********************************************************************** Price Impact Report **************************************************************************/

  }, {
    key: "impactFilterToParams",
    value: function impactFilterToParams(params) {
      return Object.assign(Object.assign({}, params), {
        dateFrom: moment.isMoment(params.dateFrom) ? moment.utc(moment(params.dateFrom, CONSTANTS.FORMAT.DATE).format(CONSTANTS.FORMAT.DATE), CONSTANTS.FORMAT.DATE).toISOString() : moment.utc(params.dateFrom, CONSTANTS.FORMAT.DATE).toISOString(),
        dateTo: moment.isMoment(params.dateTo) ? moment.utc(moment(params.dateTo, CONSTANTS.FORMAT.DATE).format(CONSTANTS.FORMAT.DATE), CONSTANTS.FORMAT.DATE).endOf('day').toISOString() : moment.utc(params.dateTo, CONSTANTS.FORMAT.DATE).endOf('day').toISOString()
      });
    }
    /** Fletches abstract releases with impact report data depending on date Filter
     * @param filter
     */

  }, {
    key: "findPriceImpactReport",
    value: function findPriceImpactReport(filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee45() {
        var _this20 = this;

        var config, endpoint, _ref44, data, list;

        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                config = Object.assign(Object.assign({}, this.config), {
                  params: this.impactFilterToParams(filter)
                });
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.IMPACT_REPORT);
                _context45.next = 4;
                return api(endpoint).get(config);

              case 4:
                _ref44 = _context45.sent;
                data = _ref44.data;
                list = new Map();
                (data || []).map(function (release) {
                  return list.set(release.id, _this20.convertRelease(release));
                });
                return _context45.abrupt("return", list);

              case 9:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));
    }
    /** Fletches totals for regular releases with impact report data depending on date Filter
     * @param releaseId
     * @param filter - date filter
     */

  }, {
    key: "findTotalWithImpact",
    value: function findTotalWithImpact(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee46() {
        var _this21 = this;

        var config, endpoint, _ref45, data;

        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                config = Object.assign(Object.assign({}, this.config), {
                  params: this.impactFilterToParams(filter)
                });
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.IMPACT_REPORT_TOTALS(releaseId));
                _context46.next = 4;
                return api(endpoint).get(config);

              case 4:
                _ref45 = _context46.sent;
                data = _ref45.data;
                return _context46.abrupt("return", (data.result || []).map(function (impact) {
                  return _this21.releaseTotalDTOConverter.toObject(impact, jsonConversions);
                }));

              case 7:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));
    }
    /**
     * Function release items for regular release with RealImpact on it
     * @param releaseId
     * @param filter
     * @returns Map of ReleaseItem with Impact report
     */

  }, {
    key: "findItemsWithImpact",
    value: function findItemsWithImpact(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee47() {
        var _this22 = this;

        var config, endpoint, _ref46, data, list;

        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                config = Object.assign(Object.assign({}, this.config), {
                  params: this.impactFilterToParams(filter)
                });
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.IMPACT_REPORT_ITEMS(releaseId));
                _context47.next = 4;
                return api(endpoint).get(config);

              case 4:
                _ref46 = _context47.sent;
                data = _ref46.data;
                list = new Map();
                (data.result || []).map(function (item) {
                  return list.set(item.productId, _this22.releaseItemsConverter.toObject(item, jsonConversions));
                });
                return _context47.abrupt("return", list);

              case 9:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));
    }
    /** Fletches totals for sellout releases with impact report data depending on date Filter
     * @param releaseId
     * @param filter
     */

  }, {
    key: "findSelloutTotalWithImpact",
    value: function findSelloutTotalWithImpact(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee48() {
        var _this23 = this;

        var config, endpoint, _ref47, data;

        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                config = Object.assign(Object.assign({}, this.config), {
                  params: this.impactFilterToParams(filter)
                });
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.IMPACT_REPORT_SELLOUT_TOTALS(releaseId));
                _context48.next = 4;
                return api(endpoint).get(config);

              case 4:
                _ref47 = _context48.sent;
                data = _ref47.data;
                return _context48.abrupt("return", (data.result || []).map(function (impact) {
                  return _this23.selloutReleaseTotalDTOConverter.toObject(impact, jsonConversions);
                }));

              case 7:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));
    }
    /**
     * Function release items for sellout release with RealImpact on it
     * @param releaseId
     * @param filter
     * @returns  Map of ReleaseItem with Impact report
     */

  }, {
    key: "findSelloutItemsWithImpact",
    value: function findSelloutItemsWithImpact(releaseId, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee49() {
        var _this24 = this;

        var config, endpoint, _ref48, data, list;

        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                config = Object.assign(Object.assign({}, this.config), {
                  params: this.impactFilterToParams(filter)
                });
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.IMPACT_REPORT_SELLOUT_ITEMS(releaseId));
                _context49.next = 4;
                return api(endpoint).get(config);

              case 4:
                _ref48 = _context49.sent;
                data = _ref48.data;
                list = new Map();
                (data.result || []).map(function (item) {
                  return list.set(item.id, _this24.selloutReleaseItemConverter.toObject(item, jsonConversions));
                });
                return _context49.abrupt("return", list);

              case 9:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));
    }
  }, {
    key: "config",

    /** Default axios config */
    get: function get() {
      return {
        responseType: 'json'
      };
    }
  }]);

  return ReleaseLayer;
}();

__decorate([Inject, __metadata("design:type", ReleaseConverter)], ReleaseLayer.prototype, "releaseConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutReleaseConverter)], ReleaseLayer.prototype, "selloutReleaseConverter", void 0);

__decorate([Inject, __metadata("design:type", ReleaseItemConverter)], ReleaseLayer.prototype, "releaseItemsConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutReleaseItemConverter)], ReleaseLayer.prototype, "selloutReleaseItemConverter", void 0);

__decorate([Inject, __metadata("design:type", ReleaseTotalDTOConverter)], ReleaseLayer.prototype, "releaseTotalDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutReleaseTotalDTOConverter)], ReleaseLayer.prototype, "selloutReleaseTotalDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", ProductPricesUploadConverter)], ReleaseLayer.prototype, "productPricesUploadConverter", void 0);

__decorate([Inject, __metadata("design:type", FinalProductPriceConverter)], ReleaseLayer.prototype, "finalProductPriceConverter", void 0);

__decorate([Inject, __metadata("design:type", ImpactRecordConverter)], ReleaseLayer.prototype, "impactRecordConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutImpactRecordConverter)], ReleaseLayer.prototype, "selloutImpactRecordConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutReleaseCategoryTotalDTOConverter)], ReleaseLayer.prototype, "selloutReleaseCategoryTotalDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutReleaseItemUpdateRequestConverter)], ReleaseLayer.prototype, "selloutReleaseItemUpdateRequestConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutTargetConverter)], ReleaseLayer.prototype, "selloutTargetConverter", void 0);

__decorate([Inject, __metadata("design:type", ReleaseItemPromosConverter)], ReleaseLayer.prototype, "releaseItemPromosConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutProductPriceImpactConverter)], ReleaseLayer.prototype, "selloutProductPriceImpactConverter", void 0);

__decorate([Inject, __metadata("design:type", SiteReleaseUploadConverter)], ReleaseLayer.prototype, "siteReleaseUploadConverter", void 0);

__decorate([Inject, __metadata("design:type", SiteReleaseConverter)], ReleaseLayer.prototype, "siteReleaseConverter", void 0);

__decorate([Inject, __metadata("design:type", SiteReleaseItemConverter)], ReleaseLayer.prototype, "siteReleaseItemConverter", void 0);

__decorate([Inject, __metadata("design:type", ReleasePartConverter)], ReleaseLayer.prototype, "releasePartConverter", void 0);

__decorate([Inject, __metadata("design:type", CommonReleaseOverviewConverter)], ReleaseLayer.prototype, "commonReleaseOverviewConverter", void 0);